const fields = (t) => ({
    config: {columns: 1},
    fields: [
        {
            name: "id",
            column: 1,
            type: "unvisible",
        },
        {
            name: "name",
            label: t ? t("common.name") : "Nazwa",
            column: 1,
            type: "text",
            mandatory: true,
            autoComplete: {
                triggers: ["template"],
                calculation: function (template) {
                    if(template){
                        return template.name
                    }
                }
            }
        },
        {
            name: "value",
            label: t ? t("common.value") : "Wartość",
            column: 1,
            type: "text",
            mandatory: true,
            autoComplete: {
                triggers: ["template"],
                calculation: function (template) {
                    if(template){
                        return template.value
                    }
                }
            }
        },
        {
            name: "comment",
            label: t ? t("common.comment") : "Komentarz",
            column: 1,
            type: "textarea",
            autoComplete: {
                triggers: ["template"],
                calculation: function (template) {
                    if(template){
                        return template.comment
                    }
                }
            }
        }
    ]
});

export default fields;
